<template>
  <div>
    <vs-tabs v-if="tabList.length > 1" :value="tabIndex">
      <vs-tab v-for="headTab in tabList" :key="`tab_${headTab.label}`" :label="headTab.label" @click="moveTab(headTab.boardId, headTab.moveType, headTab.key)" />
    </vs-tabs>
    <div v-if="tab">
      <vx-card v-if="useCard" style="width: calc(100% - 40px)">
        <component :is="tab.component" :board="board"/>
      </vx-card>
      <div v-else>
        <component :is="tab.component" :board="board"/>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from "@/views/boards/tab/breadcrumb";
import tabItems from "@/views/boards/tab/tab-items";
import TableListPage from "@/views/list/TableListPage";
import normalSearchNav from "@/views/boards/components";
import singlePageList from "@/views/boards/single-page/listIndex";

import SearchNavItemTartgets from "@/views/boards/components/SearchNavItemTartgets";
import SearchNavItemProject from "@/components/nav/SearchNavItemProject.vue";
import SearchNavYearMonth from "@/components/nav/SearchNavYearMonth.vue";
import singlePageWrite from "@/views/boards/single-page/writeIndex";
import singlePagePage from "@/views/boards/single-page/pageIndex";
export default {
  name: "Page",
  components: {
    SearchNavItemTartgets,
    SearchNavItemProject,
    SearchNavYearMonth,
    TableListPage,
  },
  computed: {
    tab() {
      return this.tabList[this.tabIndex];
    },
    boardId() {
      /*
       * 같은 그룹으로 묶은 subMenu 들 중에, 게시판 번호가 동일한 문서가 있을 경우z
       * 두 메뉴가 동시에 활성화되는 문제를 방지하기 위해
       * page 문서는 게시판 번호 앞에 _ 기호를 붙이도록 하여
       * 다른 boardId로 인식되도록 하고
       * Page.vue 에서도 예외적으로 진입할 수 있도록 하였음
       */
      const routeBoardId = this.$route.params.boardId;
      if (routeBoardId.indexOf("_") < 0) {
        return parseInt(routeBoardId);
      }

      const split = routeBoardId.split("_");
      return parseInt(split[1]);
    },
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    myInfo() {
      return this.$store.state.member.memberInfo;
    },
    useCard() {
      const exceptionId = [132, 442, 504, 506, 570, 576, 966];
      if (exceptionId.includes(this.boardId)) return false;
      else return true;
    },
  },
  data() {
    return {
      tabItems,
      breadcrumb,
      tabIndex: 0,
      tabList: [],
      board: {
        projectTitle: this.$store.state.project.projectInfo.field_name,
        writer: {}, //작성자 정보
        readonly: false, // 읽기전용인가
        isPrint: false,
        viewSaveBtn: true,
        viewRemoveBtn: true,
      },
    };
  },
  beforeMount() {
    this.initBreadcrumb();
    this.initTab();
  },
  async mounted() {
    await this.init();
  },
  methods: {
    async init() {
      await this.$store.dispatch("USER_INFO");
      this.board.writer = {
        id: this.$store.state.auth.userInfo.id,
        name: this.$store.state.auth.userInfo.name,
        company_id: this.$store.state.auth.userInfo.company_id,
        department: this.$store.state.auth.userInfo.department,
        section: this.$store.state.auth.userInfo.section,
        rank: this.$store.state.auth.userInfo.rank,
        com_name: "",
      };

      await this.$store.dispatch("company/LOAD_COMPANY", {
        companyId: this.board.writer.company_id,
      });
      this.board.writer.com_name = this.$store.state.company.companyInfo.com_name;
      if (!this.board.writer.section) {
        this.board.writer.section = this.board.writer.com_name;
      }
    },
    initBreadcrumb() {
      const breadcrumb = [{ title: "Home" }];
      let key = `${this.boardId}`;
      // 브래드크럼의 이름이 프로젝트 번호와 연결되어 있으면, 해당 정보를 가져온다
      if (this.breadcrumb[`${this.projectId}.${this.boardId}`]) {
        key = `${this.projectId}.${this.boardId}`;
      }
      breadcrumb.push(...this.breadcrumb[key]);

      if (breadcrumb.length > 0) breadcrumb[breadcrumb.length - 1].active = true;
      this.$store.commit("menu/UPDATE_PAGE_LIST", breadcrumb);
    },
    async initTab() {
      await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
      if (this.boardId === 53 || this.boardId === 54 || this.boardId === 55) {
        this.addTab(53);
        this.addTab(54);
        this.addTab(55);
        if (this.boardId === 53) this.tabIndex = 0;
        else if (this.boardId === 54) this.tabIndex = 1;
        else if (this.boardId === 55) this.tabIndex = 2;
      } else if (this.boardId === 58 || this.boardId === 59 || this.boardId === 60) {
        this.addTab(58);
        this.addTab(59);
        this.addTab(60);
        if (this.boardId === 58) this.tabIndex = 0;
        else if (this.boardId === 59) this.tabIndex = 1;
        else if (this.boardId === 60) this.tabIndex = 2;
      } else if (this.boardId === 62 || this.boardId === 63) {
        this.addTab(62);
        this.addTab(63);
        this.addSubTab("아차사고D/B");
        if (this.boardId === 62) this.tabIndex = 0;
        else if (this.boardId === 63) this.tabIndex = 1;
      } else if (this.boardId === 64 || this.boardId === 65 || this.boardId === 66 || this.boardId === 67 || this.boardId === 68 || this.boardId === 69) {
        this.addTab(64);
        this.addTab(65);
        this.addTab(66);
        this.addTab(67);
        this.addTab(68);
        this.addTab(69);
        if (this.boardId === 64) this.tabIndex = 0;
        else if (this.boardId === 65) this.tabIndex = 1;
        else if (this.boardId === 66) this.tabIndex = 2;
        else if (this.boardId === 67) this.tabIndex = 3;
        else if (this.boardId === 68) this.tabIndex = 4;
        else if (this.boardId === 69) this.tabIndex = 5;
      } else if (this.boardId === 71 || this.boardId === 72 || this.boardId === 73 || this.boardId === 74 || this.boardId === 75) {
        this.addTab(74);
        this.addTab(75);
        this.addTab(71);
        this.addTab(72);
        this.addTab(73);
        if (this.boardId === 74) this.tabIndex = 0;
        else if (this.boardId === 75) this.tabIndex = 1;
        else if (this.boardId === 71) this.tabIndex = 2;
        else if (this.boardId === 72) this.tabIndex = 3;
        else if (this.boardId === 73) this.tabIndex = 4;
      } else if (this.boardId === 76 || this.boardId === 77) {
        this.addTab(76);
        this.addTab(77);
        this.addSubTab("형태별분류");
        if (this.boardId === 76) this.tabIndex = 0;
        else if (this.boardId === 77) this.tabIndex = 1;
      } else if (this.boardId === 78 || this.boardId === 79 || this.boardId === 87) {
        this.addTab(78);
        this.addTab(79);
        this.addTab(87);
        if (this.boardId === 78) this.tabIndex = 0;
        else if (this.boardId === 79) this.tabIndex = 1;
        else if (this.boardId === 87) this.tabIndex = 2;
      } else if (this.boardId === 80 || this.boardId === 81 || this.boardId === 88) {
        this.addTab(80);
        this.addTab(81);
        this.addTab(88);
        if (this.boardId === 80) this.tabIndex = 0;
        else if (this.boardId === 81) this.tabIndex = 1;
        else if (this.boardId === 88) this.tabIndex = 2;
      } else if (this.boardId === 82 || this.boardId === 83) {
        this.addTab(82);
        this.addTab(83);
        if (this.boardId === 82) this.tabIndex = 0;
        else if (this.boardId === 83) this.tabIndex = 1;
      } else if (this.boardId === 84 || this.boardId === 85) {
        this.addTab(84);
        this.addTab(85);
        if (this.boardId === 84) this.tabIndex = 0;
        else if (this.boardId === 85) this.tabIndex = 1;
      } else if (this.boardId === 89) {
        this.addTab(89);
        this.addSubTab("조직도");
        if (this.boardId === 89) this.tabIndex = 0;
        // } else if (parseInt(this.projectId) === 1 && (this.boardId === 286 || this.boardId === 287)) {
        //   this.addTab(286);
        //   this.addTab(287);
        //
        //   if (this.boardId === 286) this.tabIndex = 0;
        //   if (this.boardId === 287) this.tabIndex = 1;

        // } else if (parseInt(this.projectId) === 2 && (this.boardId === 129 || this.boardId === 130)) {
        //   this.addTab(130)
        //   this.addTab(129)
        //
        //   if (this.boardId === 130) this.tabIndex = 0
        //   if (this.boardId === 129) this.tabIndex = 1

        // } else if ((parseInt(this.projectId) === 3 || parseInt(this.projectId) === 4 || parseInt(this.projectId) === 5) && (this.boardId === 129 || this.boardId === 130)) {
        //   this.addTab(130)
        //   this.addTab(129)
        //
        //   if (this.boardId === 130) this.tabIndex = 0
        //   if (this.boardId === 129) this.tabIndex = 1
        //
        // } else if (parseInt(this.projectId) !== 3 && (this.boardId === 129 || this.boardId === 287)) {
        //   this.addTab(287)
        //   this.addTab(129)
        //   if (this.boardId === 287) this.tabIndex = 0
        //   if (this.boardId === 129) this.tabIndex = 1
      } else if (this.boardId === 108 || this.boardId === 156 || this.boardId === 157 || this.boardId === 158 || this.boardId === 159 || this.boardId === 305) {
        this.addTab(108);
        this.addTab(156);
        this.addTab(157);
        this.addTab(158);
        this.addTab(159);
        this.addTab(305);
        if (this.boardId === 108) this.tabIndex = 0;
        if (this.boardId === 156) this.tabIndex = 1;
        if (this.boardId === 157) this.tabIndex = 2;
        if (this.boardId === 158) this.tabIndex = 3;
        if (this.boardId === 159) this.tabIndex = 4;
        if (this.boardId === 305) this.tabIndex = 5;
      } else if (this.boardId === 119 || this.boardId === 120 || this.boardId === 121 || this.boardId === 122 || this.boardId === 123 || this.boardId === 124 || this.boardId === 125) {
        this.addTab(119);
        this.addTab(120);
        // this.addTab(121) // 해당 탭을 숨겨 달라는 요청이 있었음..
        this.addTab(122);
        this.addTab(123);
        // this.addTab(124) // 2022.12.19 https://app.clickup.com/t/864dhnpjc
        this.addTab(125);
        if (this.boardId === 119) this.tabIndex = 0;
        else if (this.boardId === 120) this.tabIndex = 1;
        // else if (this.boardId === 121) this.tabIndex = 2 // 해당 탭을 숨겨 달라는 요청이 있었음..
        else if (this.boardId === 122) this.tabIndex = 2;
        else if (this.boardId === 123) this.tabIndex = 3;
        else if (this.boardId === 124) this.tabIndex = 4;
        else if (this.boardId === 125) this.tabIndex = 5;
      } else if (this.boardId === 144 || this.boardId === 145 || this.boardId === 146) {
        this.addTab(144);
        this.addTab(145);
        this.addTab(146);
        if (this.boardId === 144) this.tabIndex = 0;
        if (this.boardId === 145) this.tabIndex = 1;
        if (this.boardId === 146) this.tabIndex = 2;
      } else if (this.boardId === 216 || this.boardId === 217 || this.boardId === 218) {
        this.addTab(216);
        this.addTab(217);
        this.addTab(218);
        if (this.boardId === 216) this.tabIndex = 0;
        if (this.boardId === 217) this.tabIndex = 1;
        if (this.boardId === 218) this.tabIndex = 2;
      } else if (this.boardId === 239 || this.boardId === 240 || this.boardId === 241) {
        this.addTab(239);
        this.addTab(240);
        this.addTab(241);
        if (this.boardId === 239) this.tabIndex = 0;
        if (this.boardId === 240) this.tabIndex = 1;
        if (this.boardId === 241) this.tabIndex = 2;
      } else if (this.boardId === 265 || this.boardId === 266) {
        this.addTab(265);
        this.addTab(266);
        if (this.boardId === 265) this.tabIndex = 0;
        if (this.boardId === 266) this.tabIndex = 1;
      } else if (this.boardId === 268 || this.boardId === 269) {
        this.addTab(268);
        this.addTab(269);
        if (this.boardId === 268) this.tabIndex = 0;
        if (this.boardId === 269) this.tabIndex = 1;
      } else if (this.boardId === 270 || this.boardId === 271) {
        this.addTab(270);
        this.addTab(271);
        if (this.boardId === 270) this.tabIndex = 0;
        if (this.boardId === 271) this.tabIndex = 1;
      } else if (this.boardId === 272 || this.boardId === 273) {
        this.addTab(272);
        this.addTab(273);
        if (this.boardId === 272) this.tabIndex = 0;
        if (this.boardId === 273) this.tabIndex = 1;
      } else if (this.boardId === 275 || this.boardId === 276 || this.boardId === 277 || this.boardId === 278) {
        this.addTab(275);
        this.addTab(276);
        this.addTab(277);
        this.addTab(278);
        if (this.boardId === 275) this.tabIndex = 0;
        if (this.boardId === 276) this.tabIndex = 1;
        if (this.boardId === 277) this.tabIndex = 2;
        if (this.boardId === 278) this.tabIndex = 3;
      } else if (this.boardId === 294 || this.boardId === 295) {
        this.addTab(294);
        this.addTab(295);
        if (this.boardId === 294) this.tabIndex = 0;
        if (this.boardId === 295) this.tabIndex = 1;
      } else if (this.boardId === 352 || this.boardId === 353 || this.boardId === 354) {
        this.addTab(352);
        this.addTab(353);
        this.addTab(354);
        if (this.boardId === 352) this.tabIndex = 0;
        if (this.boardId === 353) this.tabIndex = 1;
        if (this.boardId === 354) this.tabIndex = 2;
      } else if (this.boardId === 385 || this.boardId === 392 || this.boardId === 394) {
        this.addTab(385);
        this.addTab(392);
        this.addTab(394);
        if (this.boardId === 385) this.tabIndex = 0;
        if (this.boardId === 392) this.tabIndex = 1;
        if (this.boardId === 394) this.tabIndex = 2;
      } else if (this.boardId === 386 || this.boardId === 393 || this.boardId === 395) {
        this.addTab(386);
        this.addTab(393);
        this.addTab(395);
        if (this.boardId === 386) this.tabIndex = 0;
        if (this.boardId === 393) this.tabIndex = 1;
        if (this.boardId === 395) this.tabIndex = 2;
      } else if (this.boardId === 433) {
        if (this.myInfo.can_employee_bulk_register) {
          this.addTab(433);
          this.addSubTab("employees");
          if (this.boardId === 433) this.tabIndex = 0;
          if (this.boardId === "employees") this.tabIndex = 1;
        } else this.addTab(this.boardId);
      } else if (this.$route.params.boardId === "checkCerebrovascular" || this.boardId === 368 || this.boardId === 369) {
        this.addSubTab("checkCerebrovascular");
        this.addTab(368);
        this.addTab(369);
        if (this.$route.params.boardId === "checkCerebrovascular") this.tabIndex = 0;
        if (this.boardId === 368) this.tabIndex = 1;
        if (this.boardId === 369) this.tabIndex = 2;
      } else if (this.myInfo.can_risk_assessment_bulk_register && (this.boardId === 450 || this.$route.params.boardId === "riskassessment450")) {
        this.addTab(450);
        this.addSubTab("riskassessment450");
        if (this.boardId === 450) this.tabIndex = 0;
        if (this.$route.params.boardId === "riskassessment450") this.tabIndex = 1;
      } else if (this.myInfo.can_risk_assessment_bulk_register && (this.boardId === 460 || this.$route.params.boardId === "riskassessment460")) {
        this.addTab(460);
        this.addSubTab("riskassessment460");
        if (this.boardId === 460) this.tabIndex = 0;
        if (this.$route.params.boardId === "riskassessment460") this.tabIndex = 1;
      } else if (this.boardId === 502 || this.boardId === "lungcancer502" || this.boardId === 503 || this.boardId === "lungcancer503" ) {
        this.addTab(502);
        this.addSubTab("lungcancer502");
        this.addTab(503);
        this.addSubTab("lungcancer503");
        if (this.boardId === 502) this.tabIndex = 0;
        if (this.boardId === "lungcancer502") this.tabIndex = 1;
        if (this.boardId === 503) this.tabIndex = 2;
        if (this.boardId === "lungcancer503") this.tabIndex = 3;
      } else if (
        this.boardId === 570 ||
        this.boardId === 576 ||
        this.boardId === 577 ||
        this.$route.params.boardId === "completionresults570" ||
        this.$route.params.boardId === "completionresults576" ||
        this.$route.params.boardId === "completionresults577"
      ) {
        this.addTab(570);
        this.addSubTab("completionresults570");
        this.addTab(576);
        this.addSubTab("completionresults576");
        this.addTab(577);
        this.addSubTab("completionresults577");
        if (this.boardId === 570) this.tabIndex = 0;
        if (this.$route.params.boardId === "completionresults570") this.tabIndex = 1;
        if (this.boardId === 576) this.tabIndex = 2;
        if (this.$route.params.boardId === "completionresults576") this.tabIndex = 3;
        if (this.boardId === 577) this.tabIndex = 4;
        if (this.$route.params.boardId === "completionresults577") this.tabIndex = 5;
      } else if (this.boardId === 637) {
        this.addTab(637);
        this.addPageTab(637, '교량 대량입력');
        if (this.boardId === 637) this.tabIndex = 1;
      } else if (this.boardId === 638) {
        this.addTab(638);
        this.addPageTab(638, '터널 대량입력');
        if (this.boardId === 638) this.tabIndex = 1;
      } else if (this.boardId === 639) {
        this.addTab(639);
        this.addPageTab(639, '옹벽 및 절토사면 대량입력');
        if (this.boardId === 639) this.tabIndex = 1;
      } else if (this.boardId === 685 || this.boardId === 686) {
        this.addPageTab(685);
        this.addPageTab(686);
        if (this.boardId === 685) this.tabIndex = 0;
        if (this.boardId === 686) this.tabIndex = 1;
      } else if (this.boardId === 940 || this.boardId === 938) {
        this.addTab(940);
        this.addTab(938);
        if (this.boardId === 940) this.tabIndex = 0;
        if (this.boardId === 938) this.tabIndex = 1;
      } else if (this.boardId === 966) {
        this.addPageTab(966);
      } else {
        this.addTab(this.boardId);
      }
    },
    addTab(_boardId) {
      const boardId = `${_boardId}`;
      const item = this.tabItems[boardId];
      if (item) {
        const slug = `board-${_boardId}`;
        const component = singlePageWrite[`${_boardId}_write`];
        this.tabList.push({ boardId, slug, component, ...item });
      }
    },
    addPageTab(_boardId, label) {
      const boardId = `${_boardId}`;
      const item = this.tabItems[boardId];
      if (item) {
        const slug = `board-${_boardId}`;
        const component = singlePagePage[`${_boardId}_page`];
        this.tabList.push({
          ...item,
          moveType: 'page',
          label: label || item.label,
          boardId,
          component,
        });
      }
    },
    addSubTab(key) {
      if (key === "아차사고D/B") this.tabList.push({ key: "아차사고D/B", label: "아차사고 D/B", component: "exception01", exception: true });
      if (key === "형태별분류") this.tabList.push({ key: "형태별분류", label: "형태별 분류", component: "exception02", exception: true });
      if (key === "조직도") this.tabList.push({ key: "조직도", label: "조직도", component: "exception03", exception: true });
      if (key === "현장대리인_안전보건_경영방침") this.tabList.push({ key: "현장대리인_안전보건_경영방침", label: "현장대리인 안전보건 경영방침", component: "exception04", exception: true });
      if (key === "checkCerebrovascular") this.tabList.push({ key: "checkCerebrovascular", label: "뇌심혈관질환 발병위험도 평가 및 사후관리 절차 개요", component: "exception06", exception: true });
      if (key === "employees") this.tabList.push({ key: "employees", label: "종사자 일괄 등록", exception: true });
      if (key === "riskassessment450") this.tabList.push({ key: "riskassessment450", label: "위험성평가 엑셀 업로드", exception: true });
      if (key === "riskassessment460") this.tabList.push({ key: "riskassessment460", label: "위험성평가 엑셀 업로드", exception: true });
      if (key === "lungcancer502") this.tabList.push({ key: "lungcancer502", label: "폐암검진결과 엑셀 업로드", exception: true });
      if (key === "lungcancer503") this.tabList.push({ key: "lungcancer503", label: "폐암정밀검진 엑셀 업로드", exception: true });
      if (key === "completionresults570") this.tabList.push({ key: "completionresults570", label: "정기 교육 엑셀 업로드", exception: true });
      if (key === "completionresults576") this.tabList.push({ key: "completionresults576", label: "채용시 교육 엑셀 업로드", exception: true });
      if (key === "completionresults577") this.tabList.push({ key: "completionresults577", label: "관리감독자 교육 엑셀 업로드", exception: true });
    },
    moveTab(boardId, moveType, key) {
      const name = this.projectId ? `${moveType}|tab` : `root|${moveType}|tab`;
      if (moveType === 'excel-upload' || moveType === 'page' ) return this.$router.push({ name, params: { boardId } });

      if (boardId) {
        if (this.projectId) {
          this.$router.push({ name: "list|tab", params: { boardId } });
        } else {
          this.$router.push({ name: "root|list|tab", params: { boardId } });
        }
      }
      if (key) {
        if (key === "아차사고D/B") {
          const breadcrumb = [{ title: "아차사고" }, { title: "아차사고관리" }, { title: "아차사고 D/B" }];
          if (breadcrumb.length > 0) breadcrumb[breadcrumb.length - 1].active = true;
          this.$store.commit("menu/UPDATE_PAGE_LIST", breadcrumb);
        } else if (key === "현장대리인_안전보건_경영방침") {
          this.$router.push({ name: "list|tab", params: { boardId: "현장대리인_안전보건_경영방침" } });
        } else if (key === "checkCerebrovascular") {
          this.$router.push({ name: "list|tab", params: { boardId: "checkCerebrovascular" } });
        } else if (key === "employees") {
          this.$router.push({ name: "employees" });
        } else if (key === "riskassessment450") {
          this.$router.push({ name: "riskassessment450" });
        } else if (key === "riskassessment460") {
          this.$router.push({ name: "riskassessment460" });
        } else if (key === "lungcancer502") {
          this.$router.push({ name: "lungcancer502" });
        } else if (key === "lungcancer503") {
          this.$router.push({ name: "lungcancer503" });
        } else if (key === "completionresults570") {
          this.$router.push({ name: "completionresults570" });
        } else if (key === "completionresults576") {
          this.$router.push({ name: "completionresults576" });
        } else if (key === "completionresults577") {
          this.$router.push({ name: "completionresults577" });
        }
      }
    },
  },
};
</script>

<style scoped></style>
